import {
  Box,
  Code,
  Heading,
  Text,
  VStack,
  List,
  Link,
} from "@chakra-ui/react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from 'rehype-raw'

export function ReportContent({ report }: { report: any }) {
  if (!report) return null

  return (
    <Box 
      mt={8} 
      p={6}  
      bg="white"
      // overflowY="auto"
      // maxH="700px"
      >
      <VStack align="start" gap={4}>
        {/* <Heading size="md">{report.report_name || "제목없음"}</Heading> */}
        {/* <Text fontSize="sm" color="gray.600">
          {report.report_description || "설명 없음"}
        </Text> */}

        <Box
          mt={2}
          p={4}
          w="full"
          bg="white"
          fontSize="sm"
        >
          {report.content ? (
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              components={{
                h1: ({ children }) => <Heading as="h1" size="lg" mt={4} mb={2}>{children}</Heading>,
                h2: ({ children }) => <Heading as="h2" size="md" mt={4} mb={2}>{children}</Heading>,
                h3: ({ children }) => <Heading as="h3" size="sm" mt={4} mb={2}>{children}</Heading>,
                p: ({ children }) => <Text mb={6}>{children}</Text>,

                // ✅ Wrap with List.Root
                ul: ({ children }) => (
                  <List.Root as="ul" style={{ listStyleType: "disc" }} pl={6} mb={2}>
                    {children}
                  </List.Root>
                ),
                ol: ({ children }) => (
                  <List.Root as="ol" style={{ listStyleType: "decimal" }} pl={6} mb={2}>
                    {children}
                  </List.Root>
                ),

                // ✅ Use List.Item inside List.Root
                li: ({ children }) => (
                  <List.Item>{children}</List.Item>
                ),

                a: ({ href, children }) => (
                  <Link
                    href={href}
                    color="blue.500"
                    // textDecoration="underline"
                  >
                    {children}
                  </Link>
                ),

                code: ({ children }) => (
                  <Code colorScheme="gray" px={1} py={0.5} borderRadius="md">
                    {children}
                  </Code>
                ),
              }}
            >
              {report.content}
            </ReactMarkdown>
          ) : (
            "내용 없음"
          )}
        </Box>
      </VStack>
    </Box>
  )
}
